import React, { Component } from "react";
import AntdDescriptions, {DescriptionsProps} from "antd/lib/descriptions";
import "antd/lib/descriptions/style";

const { Item } = AntdDescriptions;

export default class Descriptions extends Component<DescriptionsProps> {
  static Item = Item;
  render() {
    const { children } = this.props;
    return <AntdDescriptions {...this.props}>{children}</AntdDescriptions>;
  }
}



// WEBPACK FOOTER //
// ./src/components/descriptions/index.tsx